export default __webpack_public_path__ + "static/media/DSC_0921.9b582927.JPG";